import React from 'react';

interface SimulationStatsProps {
  elapsedTime: number;
  timeScale: number;
  darkMode: boolean;
}

export const SimulationStats: React.FC<SimulationStatsProps> = ({ elapsedTime, timeScale, darkMode }) => (
  <div className="absolute top-6 left-6 z-10 pointer-events-none flex flex-col gap-2">
    <div className={`backdrop-blur-md px-4 py-2 rounded-2xl shadow-xl border flex flex-col items-center min-w-[100px] ${darkMode ? 'bg-neutral-800 text-white border-white/5' : 'bg-neutral-900 text-white border-white/10'}`}>
      <span className="text-[9px] uppercase font-black opacity-60">Elapsed</span>
      <span className="text-lg font-mono font-bold">{(elapsedTime/1000).toFixed(2)}s</span>
    </div>
    <div className={`backdrop-blur-md px-4 py-2 rounded-2xl shadow-xl border flex flex-col items-center min-w-[100px] ${darkMode ? 'bg-neutral-800 text-white border-white/5' : 'bg-neutral-900 text-white border-white/10'}`}>
      <span className="text-[9px] uppercase font-black opacity-60">Speed</span>
      <span className="text-lg font-mono font-bold">{timeScale.toFixed(2)}x</span>
    </div>
  </div>
);
